/**
 * Tabs Block — Interactive Functionality
 *
 * Desktop: switches between .tabs__panel elements via .tabs__control buttons
 * Mobile:  toggles .tabs__mobile-panel open/closed via .tabs__mobile-control buttons
 */

document.addEventListener('DOMContentLoaded', () => {
	const tabsBlocks = document.querySelectorAll('[data-tabs-block]');

	tabsBlocks.forEach((block) => {
		// ── Desktop ────────────────────────────────────────────────────────────
		const controls = block.querySelectorAll('.tabs__controls .tabs__control');
		const panels   = block.querySelectorAll('.tabs__right .tabs__panel');

		controls.forEach((control, index) => {
			control.addEventListener('click', () => {
				switchTab(controls, panels, index);
			});

			control.addEventListener('keydown', (e) => {
				let targetIndex = index;

				if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
					targetIndex = (index + 1) % controls.length;
				} else if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
					targetIndex = (index - 1 + controls.length) % controls.length;
				} else if (e.key === 'Home') {
					targetIndex = 0;
				} else if (e.key === 'End') {
					targetIndex = controls.length - 1;
				} else {
					return;
				}

				e.preventDefault();
				controls[targetIndex].focus();
				switchTab(controls, panels, targetIndex);
			});
		});

		// ── Mobile ─────────────────────────────────────────────────────────────
		const mobileControls = block.querySelectorAll('.tabs__mobile-control');

		mobileControls.forEach((control) => {
			control.addEventListener('click', () => {
				const targetIndex = parseInt( control.getAttribute('data-mobile-target'), 10 );
				const allItems    = block.querySelectorAll('.tabs__mobile-item');
				const allPanels   = block.querySelectorAll('.tabs__mobile-panel');

				allItems.forEach((item, i) => {
					const isActive = i === targetIndex;
					item.classList.toggle('is-active', isActive);
				});

				allPanels.forEach((panel, i) => {
					panel.classList.toggle('is-active', i === targetIndex);
				});
			});
		});
	});
});

function switchTab(controls, panels, activeIndex) {
	controls.forEach((ctrl, i) => {
		const isActive = i === activeIndex;
		ctrl.classList.toggle('is-active', isActive);
		ctrl.setAttribute('aria-selected', isActive ? 'true' : 'false');
		ctrl.setAttribute('tabindex', isActive ? '0' : '-1');
	});

	panels.forEach((panel, i) => {
		const isActive = i === activeIndex;
		panel.classList.toggle('is-active', isActive);
		panel.setAttribute('aria-hidden', isActive ? 'false' : 'true');
	});
}